export const notificationCtaTargets = [
  'subject_page',
  'custom_url',
  'none',
] as const

type NotificationTemplateCtaTarget = typeof notificationCtaTargets[number]
export default NotificationTemplateCtaTarget
